import { connect } from "react-redux";
import B2CLoggedIn from "./B2CLoggedIn";
import { bindActionCreators } from "redux";
import {caseStatusUpdateRequest, caseListRequest} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
    caseListResponse : state.CarLoan.caseListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseStatusUpdateRequest,
        caseListRequest,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(B2CLoggedIn);